/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @angular-eslint/component-selector */
import { Component, OnInit } from '@angular/core';
import { EmployeesService } from 'src/app/services/employees.service';
import { RegistroService } from 'src/app/services/registro.service';

@Component({
    selector: 'registro-horas',
    templateUrl: './registro-horas.component.html',
    styleUrls: ['./registro-horas.component.scss']
})
export class RegistroHorasComponent implements OnInit {

    // #region Propiedades públicas
    tieneRegistro: boolean = false;
    firma: string = '';
    // #endregion

    constructor(
        protected registroService: RegistroService,
        protected empleadosService: EmployeesService
    ) { }

    ngOnInit() {
        this.registroService.comprobarRegistro().subscribe((registro) => {
            if (registro !== null) {
                this.tieneRegistro = true;
            }
            console.log('Tiene registro', this.tieneRegistro);
        });

        // Obtención de la firma del empleado
        this.empleadosService.getSignature()
            .subscribe((firma: string) => {
                this.firma = firma;
            });
    }

    // #region Métodos públicos
    finalizar(): void {
        this.registroService.finalizarRegistro()
            .subscribe((registro: boolean) => {
                if (registro) {
                    this.tieneRegistro = false;
                }
            });
    }

    iniciar(): void {
        this.registroService.iniciarRegistro()
            .subscribe((registro: boolean) => {
                if (registro) {
                    this.tieneRegistro = true;
                }
            });
    }

    onFirmaGuardada(firma: string): void {
        this.firma = firma;
    }
    // #endregion
}
